<template>
    <div class="l-remake-contanier">
        <div class="l-remake-select">
            <div class="l-remake-select-wrap" @click="onShowSelect">
                {{ yearValue }}年度<span class="l-remake-select-icon"></span>
            </div>
            <ul v-show="isSelect" class="l-remake-select-options">
                <li @click="onSelectItem(item)" v-for="item in yearList" :key="item" class="l-remake-select-option">
                    {{ item }}年度
                </li>
            </ul>
        </div>

        <ul class="l-remake-tab-list">
            <li
                v-for="(item, index) in termList"
                :key="index"
                class="l-remake-tab-item"
                :class="{ active: termActive === index }"
                @click="onTableCut(item, index)">
                {{ item.termName }}{{ CourseTypeMap[item.productType] }}
            </li>
        </ul>

        <div v-if="termList[0].termId" class="l-remake-tab-content">
            <div class="remake-title">
                <span class="user-name">
                    {{ userData.cnName ? userData.cnName : "学员" }}
                </span>
                你好！恭喜你完成了闯关，快来看看你的赛季末战况吧！
            </div>
            <div class="content">
                <div class="season-card-list">
                    <div class="season-card">
                        <span class="season-card-label">通关关卡</span>
                        <img src="../images/remake/card-cup.png" class="season-card-cup">
                        <span class="season-card-cup-text">
                            {{ courseData.score.stage1 }}{{ courseData.score.lesson1 }}-{{ courseData.score.stage2 }}{{ courseData.score.lesson2 }}
                        </span>
                    </div>
                    <!-- <div class="season-card">
                        <span class="season-card-label">收获LILY币</span>
                        <img src="../images/remake/card-coin.png" class="season-card-coin">
                        <span class="season-card-coin-text">
                            x{{ courseData.score.rewardCoins || 0 }}
                        </span>
                    </div> -->
                    <template v-for="(item, index) in courseData.score.elements">
                        <div v-if="item.elementScore !== -1" :key="index" class="season-card">
                            <span class="season-card-label">{{ item.elementName }}</span>
                            <img src="../images/remake/card-level.png" class="season-card-level">
                            <div v-if="item.scoreType == 2" class="card-list-star">
                                <img v-for="nums in starImgList" :key="nums" :src="nums <= item.elementScore
                                        ? require('../images/remake/star.png')
                                        : require('../images/remake/noStar.png')
                                    " />
                            </div>
                            <div v-else-if="item.scoreType == 1" class="season-card-level-text">
                                {{ item.elementScore }}
                            </div>
                            <div v-else-if="item.scoreType == 3" class="season-card-level-text">
                                {{ item.elementScore }}%
                            </div>
                        </div>
                    </template>
                </div>
                <div class="remark" v-html="courseData.comment"></div>
            </div>
        </div>
        <div class="l-remake-no-data" v-else>
            完成闯关就会获得你的专属赛季末战况哦~
        </div>
    </div>
</template>

<script>
import ClasscoreModel from "@/models/classcore"
import UsercenterModel from "@/models/usercenter"
import { CourseType, StarList } from "./../constants/enum"
import { CourseTypeMap } from "@/constants/enum"

const classcoreModel = new ClasscoreModel()
const usercenterModel = new UsercenterModel()
export default {
    name: "Remake",
    components: {},
    computed: {
        isStart: () => {
            return (type) => {
                let flag = false
                StarList.forEach((item) => {
                    if (item === type) {
                        flag = true
                    }
                })
                return flag
            }
        },
    },
    data() {
        return {
            CourseTypeMap,
            StarList,
            CourseType,
            starImgList: [1, 2, 3, 4, 5],
            yearValue: new Date().getFullYear(),
            isSelect: false,
            yearList: [],
            termList: [{ classTermName: "" }],
            //当前选中赛季信息
            termContent: {},
            termActive: 0,
            //用户信息
            userData: {},

            //段位类型选中
            courseAvtive: 0,
            //当前类型信息
            courseData: {
                comment: "",
                lessonInfo: {
                    danName: "",
                    endLessonName: "",
                    startLessonName: "",
                    rewardCoins: 0,
                    elementInfos: [],
                },
            },
        }
    },
    methods: {
        //获取赛季列表
        getRemakeList() {
            let params = {
                year: this.yearValue,
            }
            this.$lLoading.show()
            classcoreModel
                .getUserTermView(params)
                .then((res) => {
                    if (res.status === 0) {
                        res.data ? this.termList = res.data : this.termList = [{ classTermName: "" }]
                        this.termContent = this.termList[this.termActive]
                        this.courseData =
                            this.termContent
                        // this.courseData =
                        //     this.termContent.userComments[this.courseAvtive];
                        // if (!this.termContent.readStatus) {
                        //     this.getUserTermRead(this.termContent.classTermId);
                        // }
                    }
                    this.$lLoading.hide()
                })
                .catch(() => {
                    this.$lLoading.hide()
                })
        },
        // 获取年份
        async getUserTermListYear() {
            let res = await classcoreModel.getUserTermListYear()
            if (res.status === 0) {
                this.yearList = res.data
            }
        },
        // 获取用户数据
        getUser() {
            usercenterModel.getUser().then((res) => {
                if (res.status === 0) {
                    this.userData = res.data
                }
            })
        },
        onShowSelect() {
            this.isSelect = !this.isSelect
        },
        //选择年份
        onSelectItem(item) {
            this.yearValue = item
            this.isSelect = false
            this.termActive = 0
            this.courseAvtive = 0
            this.getRemakeList()
        },
        //切换赛季
        onTableCut(item, index) {
            if (index === this.termActive) {
                return
            }
            this.termActive = index
            this.termContent = item
            this.courseAvtive = 0
            this.courseData = this.termContent
            // if (!this.termContent.readStatus) {
            //     this.termList[this.termActive].readStatus = 1;
            //     this.getUserTermRead(this.termContent.classTermId);
            // }
        },

        //标记用户已读
        // getUserTermRead(id) {
        //     let params = {
        //         termCommentId: id,
        //     };
        //     classcoreModel.getUserTermRead(params);
        // },

        //切换关卡类型
        onCourseTab(item, index) {
            if (index === this.courseAvtive) {
                return
            }
            this.courseAvtive = index
            this.courseData = item
        },
    },
    mounted() {
        this.getUser()
        this.getRemakeList()
        this.getUserTermListYear()
    },
    created() {

    },
}
</script>

<style scoped>
.l-remake-contanier {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
}
.l-remake-select {
    position: relative;
    width: 230px;
}
.l-remake-select-wrap {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    height: 50px;
    padding-left: 30px;
    background: #fff3d3;
    border-radius: 24px;
    box-shadow: 0px 1px 0px 1px rgba(153,37,6,0.41), 0px -2px 4px 2px #ebc595 inset; 
    font-size: 24px;
    font-weight: bold;
    color: #6F6C68;
    cursor: pointer;
}
.l-remake-select-icon {
    width: 0;
    height: 0;
    border-left: 16px solid transparent;
    border-right: 16px solid transparent;
    border-top: 16px solid #7AA5DF;
    border-radius: 16px;
    margin-left: 20px;
}
.l-remake-select-options {
    position: absolute;
    top: 54px;
    left: 0;
    width: 100%;
    margin: 0;
    padding: 0;
    background-color: #fff3d3;
    border: 1px solid #ccc;
    border-radius: 24px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    z-index: 10;
    list-style: none;
}
.l-remake-select-option {
    padding: 12px 16px;
    font-size: 24px;
    font-weight: bold;
    color: #6F6C68;
    cursor: pointer;
}

.l-remake-tab-list {
    display: flex;
    gap: 24px;
    padding: 12px 0;
    margin: 0;
    margin-top: 20px;
    border-bottom: 4px solid #fff;
    list-style: none;
    overflow: auto;
}
.l-remake-tab-list::-webkit-scrollbar {
    display: none;
}
.l-remake-tab-item {
    font-size: 40px;
    font-weight: bold;
    color: #fff;
    cursor: pointer;
    flex-shrink: 0;
}
.l-remake-tab-item.active {
    color: #FFFD43;
}

.l-remake-tab-content {
    flex: 1;
    padding: 0 24px;
    overflow: auto;
}
.l-remake-tab-content::-webkit-scrollbar {
    display: none;
}
.remake-title {
    padding: 20px;
    margin-bottom: 20px;
    font-size: 28px;
    color: #fff;
    text-align: left;
}
.user-name {
    font-size: 32px;
    font-weight: bold;
}
.season-card-list {
    display: flex;
    gap: 24px;
    width: 100%;
    overflow: auto;
}
.season-card-list::-webkit-scrollbar {
    display: none;
}
.season-card {
    box-sizing: border-box;
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    align-items: center;
    width: 252px;
    height: 264px;
    padding: 10px 20px;
    background: #fff3d3;
    border-radius: 24px;
    box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ecc596 inset;
}
.season-card-label {
    padding: 0 24px;
    background-color: #D8DF69;
    border-radius: 30px;
    font-size: 24px;
    font-weight: bold;
    color: #7C9126;
}
.season-card-cup {
    width: 90px;
    height: 90px;
    margin-top: 24px;
}
.season-card-cup-text {
    margin-top: 20px;
    line-height: 1;
    font-size: 24px;
    color: #966D44;
}
.season-card-coin {
    width: 165px;
    height: 89px;
    margin-top: 32px;
}
.season-card-coin-text {
    margin-top: 20px;
    font-size: 32px;
    font-weight: bold;
    color: #FF9600;
}
.season-card-level {
    width: 120px;
    height: 90px;
    margin-top: 32px;
}
.season-card-level-text {
    margin-top: 20px;
    font-size: 32px;
    font-weight: bold;
    color: #FF9600;
}

.remark {
    padding: 20px;
    margin-top: 24px;
    background: #fff3d3;
    border-radius: 24px;
    font-size: 24px;
    color: #FF9600;
    text-align: left;
}
.l-remake-no-data {
    margin-top: 120px;
    font-size: 32px;
    font-weight: bold;
    color: #fff;
}
</style>
